<template functional>
  <div>
    <template
      v-if="props.row[props.column] && !isNaN(Number(props.row[props.column]))"
    >
      <format
        :value="props.row[props['column']]"
        :messageTooltip="[
          'message.work_msg_tooltip.displayed_value',
          ':<br />',
          'message.work_msg_tooltip.quantity_x_value_unit',
          props.row.time_type.price_format == '%' 
            ? 'message.work_msg_tooltip.additional_type_hour_percent' 
            : '',
          props.row.time_type.price_format != '%' ? '+ <br />' : '',
          props.row.time_type.price_format != '%' 
            ? 'message.work_msg_tooltip.additional_type_hour' 
            : '',
          props.row.add_increment ? ' + <br /> ' : '',
          props.row.add_increment
            ? 'message.work_msg_tooltip.quantity_x_increments'
            : '',
        ]"
      />
    </template>
    <iconwarning v-else />
  </div>
</template>
<script>
export default {
  name: 'SubTotalErrorFormatter',
};
</script>
